import { ContentDataBlockEmbed } from '@amf/shared/components/content/Content';

interface EmbedProps {
  block: ContentDataBlockEmbed;
}

export function EmbedYouTube({
  block: {
    data: { width, height, embed, caption },
  },
}: EmbedProps) {
  return (
    <iframe
      className='Content__embed--youtube'
      width={width}
      height={height}
      src={embed}
      frameBorder='0'
      allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
      allowFullScreen
      title={caption}
    />
  );
}

export function EmbedInstagram({
  block: {
    data: { width, height, embed, caption },
  },
}: EmbedProps) {
  return (
    <iframe
      width={width}
      height={height + 24}
      frameBorder='0'
      scrolling='no'
      src={embed}
      className='Content__embed--instagram'
      title={caption}
    />
  );
}

export function EmbedTwitter({
  block: {
    data: { width, height, embed, caption },
  },
}: EmbedProps) {
  return (
    <iframe
      width={width}
      height={height}
      frameBorder='0'
      scrolling='no'
      src={embed}
      className='Content__embed--twitter'
      title={caption}
    />
  );
}

export default function Embed({ block }: EmbedProps) {
  return (
    <div className='Content__embed'>
      {block.data.service === 'youtube' && <EmbedYouTube block={block} />}
      {block.data.service === 'instagram' && <EmbedInstagram block={block} />}
      {block.data.service === 'twitter' && <EmbedTwitter block={block} />}
    </div>
  );
}
